import {
  fork,
  put,
  call,
  take,
  takeEvery,
  takeLatest,
  select,
  all,
  delay,
} from 'redux-saga/effects';
import app from '../app';
import {
  launchFinished,
  loadOwn,
  setShareUid,
  loadCartNumber,
} from '../actions';

function* watchLaunch() {
  yield takeLatest('LAUNCH', function*() {
    const shareUid = yield call(app.getStorage, 'SHARE_UID');
    yield put(setShareUid(shareUid));

    try {
      yield call(fetchLoginInfo);
    } catch (error) {
      yield put(launchFinished(error));
      return;
    }

    const own = yield select(state => state.own.own);

    if (own) {
      yield put(loadCartNumber(1));
      yield put(loadCartNumber(2));
    }

    yield delay(10);
    yield put(launchFinished());
  });
}

function* fetchLoginInfo() {
  yield put(loadOwn());
  const ownResult = yield take('LOAD_OWN_COMPLETION');

  if (ownResult.error) {
    throw ownResult.error;
  }

  // -201 未注册 -205 未登录
  if (app.wmp && ownResult.loginCode === -201) {
    yield call(app.wmp.auth);
    yield call(fetchLoginInfo);
  }
}

function* watchCatchError() {
  yield takeEvery('CATCH_ERROR', function*({ error }) {
    if (error.code === -203) {
      const own = yield select(state => state.own.own);

      if (own) {
        app.relaunch();
      } else {
        app.gotoLogin(true);
      }

      return;
    } else if (error.code === -206) {
      app.relaunch();
      return;
    }

    app.showTips('error', error.message);
  });
}

export default function* appSaga() {
  yield all([fork(watchLaunch), fork(watchCatchError)]);
}
